"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlowStatus = void 0;
var FlowStatus;
(function (FlowStatus) {
    FlowStatus["Archived"] = "archived";
    FlowStatus["Draft"] = "draft";
    FlowStatus["Published"] = "published";
})(FlowStatus = exports.FlowStatus || (exports.FlowStatus = {}));
